const form = document.getElementById('values-form');
const checkboxes = document.querySelectorAll('input.value-checkbox');
const labels = document.querySelectorAll('label.value-checkbox');
const continue_button = document.getElementById('submit-btn-word-selection');
const counter = document.getElementById('count');
const value_containers = document.querySelectorAll(".value-container");
let ids_selected = [];

export const selectedWords = (id) => {
    if (ids_selected.includes(id)) {
        const index = ids_selected.indexOf(id)
        if (index > -1) {
            ids_selected.splice(index, 1)
        }
    } else {
        ids_selected.push(id);
    }
    if (ids_selected.length === +64) {
        labels.forEach((item) => {
            if (item.previousElementSibling.checked !== true){
                item.style.pointerEvents = 'none';
                item.parentElement.style.cursor = "not-allowed"
            }
        });
        continue_button.style.backgroundColor = 'rgb(55,103,63, 1)';
        continue_button.style.pointerEvents = 'all';
    } else if (ids_selected.length < 64) {
        labels.forEach((item) => {
            item.style.pointerEvents = 'all';
            item.parentElement.style.cursor = "pointer"
        });
        continue_button.style.pointerEvents = 'none';
        continue_button.style.backgroundColor = 'rgb(55,103,63, .5)';
    }
    counter.innerHTML = String(ids_selected.length);
};

export const random = () => {
    reset();
    [...checkboxes]
        .map(value => ({value, sort: Math.random()}))
        .sort((a, b) => a.sort - b.sort)
        .map(({value}) => value)
        .splice(0, 64)
        .forEach((item) => {
            item.checked = true;
            selectedWords(item.id);
        });
};

export const reset = () => {
    checkboxes.forEach((item) => {
        item.checked = false;
        item.style.pointerEvents = 'all';
    });
    counter.innerHTML = 0;
    ids_selected = [];
    continue_button.style.pointerEvents = 'none';
    continue_button.style.backgroundColor = 'rgb(55,103,63, .5)';
    labels.forEach((item) => {
        item.style.pointerEvents = 'all';
    });
    value_containers.forEach((item) => {
        item.style.cursor = "pointer"
    })
};

export const submit = () => form.submit();

[...checkboxes].filter(e => e.checked).forEach(e => selectedWords(e.id));
